import { createContext, useState } from "react";
import getCountries from "../services/getCountries";
import getProvincias from "../services/WhereToBuy/warehouse/getProvincias";
import getLocalidades from "../services/WhereToBuy/warehouse/getLocalidades";
import getCorralonesConProducto from "../services/WhereToBuy/warehouse/getCorralonConProducto";
import getCorralonLocalidad from "../services/WhereToBuy/getCorralonLocalidad";
import toast from "react-hot-toast";
import { allowedCountryCodes } from "../helpers/constants";

const WhereBuyContext = createContext();

const WhereBuyProvider = ({ children }) => {
  const [objSearch, setObjSearch] = useState({});
  const [provincia, setProvincia] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [corralonesConProducto, setCorralonesConProductos] = useState(null);

  const getCountriesWhereBuy = async () => {
    try {
      const response = await getCountries();
      return response?.country;
    } catch (error) {
      toast.error('Error al obtener paises')
    }
  }
  
  const getCountriesFiltered = async () => {
    try {
      const countries = await getCountriesWhereBuy();
      const filteredCountries = countries.filter(country => allowedCountryCodes.includes(country.country_phone_code));
      return filteredCountries;
    } catch (error) {
      toast.error('Error al obtener países');
    }
  }

  const getProvinciasWhereBuy = async () => {
    try {
      const response = await getProvincias();
      return response?.data;
    } catch (error) {
      toast.error('Error al obtener provincias')
    }
  }

  const searchLocalidades = (provincia_id) => {
    setLocalidades(null);
    setObjSearch({
      ...objSearch,
      provincia_id,
    });
    getLocalidades(provincia_id).then((resp) => setLocalidades(resp.data));
  };
  const searchCorralonConProv = (provincia_id) => {
    getCorralonesConProducto({ ...objSearch, provincia_id }, provincia_id).then(
      (resp) => setCorralonesConProductos(resp.data)
    );
    setProvincia(provincia_id);
  };
  const searchCorralonConProd = (localidad_id) => {
    if (localidad_id > 0) {
      getCorralonLocalidad(objSearch, localidad_id).then((resp) =>
        setCorralonesConProductos(
          resp.data
        )
      );
    } else {
      getCorralonesConProducto({ ...objSearch, provincia }, provincia).then(
        (resp) => setCorralonesConProductos(resp.data)
      );
    }
  };

  return (
    <WhereBuyContext.Provider
      value={{
        provincia,
        setProvincia,
        localidades,
        setLocalidades,
        corralonesConProducto,
        setCorralonesConProductos,
        searchLocalidades,
        setObjSearch,
        searchCorralonConProd,
        searchCorralonConProv,
        getProvinciasWhereBuy,
        getCountriesWhereBuy,
        getCountriesFiltered
      }}
    >
      {children}
    </WhereBuyContext.Provider>
  );
};

export { WhereBuyProvider };

export default WhereBuyContext;
